import { AnySchema } from 'yup';
import formHookify from './formHookify';

export function generateHookValidator(yup: AnySchema) {
  const validate = (value: any) => yup.validate(value);
  return {
    validate: validate,
    validateWithHook: formHookify(validate),
  };
}
